import { Component } from '@angular/core';
import { CreditsModalService } from 'src/app/services/shared/credits-modal.service';
import {
  TEAM_CREDITS,
  TeamMember,
  PROJECT_INCEPTION_YEAR,
} from 'src/app/data/team-credits';

/**
 * Modale "Credits" — mostrato cliccando sul logo Diakonix in sidebar.
 * Elenca il team di sviluppo con ruoli e anno di ingresso.
 *
 * Feature pubblica (visibile a tutti gli utenti). Zero side-effect
 * sui dati, solo lettura del data file `team-credits.ts`.
 *
 * Il modale è keyboard-accessible: ESC → close.
 */
@Component({
  selector: 'app-credits-modal',
  templateUrl: './credits-modal.component.html',
  styleUrls: ['./credits-modal.component.scss'],
  standalone: false,
})

export class CreditsModalComponent {

  readonly team: readonly TeamMember[] = TEAM_CREDITS;
  readonly inceptionYear: number = PROJECT_INCEPTION_YEAR;
  readonly currentYear: number = new Date().getFullYear();

  constructor(public readonly credits: CreditsModalService) {}

  /** Iniziali due-lettere per l'avatar (es. "Gabriele Tambellini" → "GT"). */
  initials(name: string): string {
    const parts = name.trim().split(/\s+/);
    if (parts.length === 0) return '?';
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }

  /** Handler ESC per chiudere il modale. */
  onKeydown(event: KeyboardEvent): void {
    if (event.key === 'Escape') this.credits.close();
  }

  getAvatarGradient(member: TeamMember): string {
    const variants = member.roles.map(r => r.variant);
    if (variants.includes('frontend') && variants.includes('design')) {
      return 'linear-gradient(135deg, #6ea8ff, #f1003c)';
    }
    return '';
  }
  
}
